type ReturnValue<F extends (..._args: any[]) => any> = (
  ..._args: Parameters<F>
) => void;

/**
 * Returns a debounced version of given function that delays invoking `closure` until after `ms` milliseconds have elapsed since the last time the debounced function was invoked.
 */
export const debounce = <F extends (..._args: any[]) => any>(
  closure: F,
  ms: number,
): ReturnValue<F> => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      closure(...args);
    }, ms);
  };
};
